module.exports = __webpack_public_path__ + "static/media/icon-email-white.e6b2b437.svg";